import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { useSelector } from 'react-redux'
import { RowActionsMenu } from 'src/components/shared/grid/RowActionsMenu'
import type { LmsTrainingPlain } from 'src/interfaces/collectStepReference'
import type { MenuActionItem } from 'src/interfaces/ui'
import { getLmsTrainingDeletingId } from 'src/selectors/lmsTraining'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  lmsTraining: LmsTrainingPlain
  onEdit(lmsTraining: LmsTrainingPlain): void
  onDelete(lmsTraining: LmsTrainingPlain): void
}

const LmsTrainingActionsCellComponent = ({ lmsTraining, onEdit, onDelete }: Props) => {
  const deletingId = useSelector(getLmsTrainingDeletingId)
  const isDeleting = deletingId === lmsTraining.id

  const items = useMemo<MenuActionItem[]>(() => {
    return [
      {
        label: 'Edit',
        icon: <GSIcon iconName="gs_pencil" size={20} css={tw`text-shades-1000`} />,
        disabled: isDeleting,
        dataTestId: `lms-courses-list-edit-${lmsTraining.id}`,
        onClick: () => {
          onEdit(lmsTraining)
        },
      },
      {
        label: isDeleting ? 'Deleting…' : 'Delete',
        icon: <GSIcon iconName="gs_trash_can" size={20} css={tw`text-critical-500`} />,
        color: 'var(--mui-critical-500)',
        disabled: isDeleting,
        dataTestId: `lms-courses-list-delete-${lmsTraining.id}`,
        onClick: () => {
          onDelete(lmsTraining)
        },
      },
    ]
  }, [lmsTraining, isDeleting, onEdit, onDelete])

  return (
    <RowActionsMenu
      items={items}
      ariaLabel="Course actions"
      dataTestId={`lms-courses-list-actions-${lmsTraining.id}`}
    />
  )
}

export const LmsTrainingActionsCell = memo(LmsTrainingActionsCellComponent)
